// redux/actions/correos_users/correos_users.js
import axios from "axios";
import { PATH } from "../../utils";

const SESSION_EXPIRED = "SESSION_EXPIRED";

const API_BASE = `${PATH}`;

const apiService = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token =
    localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handle401 = (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenadmin");
  if (dispatch) dispatch({ type: SESSION_EXPIRED });
};

/**
 * LIST (GET /correos-users)
 */
export const actionCorreosUsersGet = () => {
  return async (dispatch) => {
    try {
      const resp = await apiService.get("correos-users", {
        headers: { ...authHeader() },
      });
      return resp.data;
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      throw error;
    }
  };
};

/**
 * CREATE (POST /correos-users)
 * payload: { correo?, correo_gmail? }
 */
export const actionCorreosUsersCreate = (payload, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      await apiService.post("correos-users", payload, {
        headers: { ...authHeader() },
      });
      await dispatch(actionCorreosUsersGet());
      onDone();
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      throw error;
    }
  };
};

/**
 * UPDATE (PATCH /correos-users/{id})
 */
export const actionCorreosUsersUpdate = (id, payload, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      await apiService.patch(`correos-users/${id}`, payload, {
        headers: { ...authHeader() },
      });
      await dispatch(actionCorreosUsersGet());
      onDone();
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      throw error;
    }
  };
};

/**
 * SET AUTORIDADES (PUT /correos-users/{id}/autoridades)
 * payload: { autoridad_ids: number[] }
 */
export const actionCorreosUsersSetAutoridades = (id, autoridadIds, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      await apiService.put(
        `correos-users/${id}/autoridades`,
        { autoridad_ids: autoridadIds },
        { headers: { ...authHeader() } }
      );
      onDone();
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      throw error;
    }
  };
};

/**
 * DELETE (DELETE /correos-users/{id}) — soft delete active=0
 */
export const actionCorreosUsersDelete = (id, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      await apiService.delete(`correos-users/${id}`, {
        headers: { ...authHeader() },
      });
      await dispatch(actionCorreosUsersGet());
      onDone();
    } catch (error) {
      if (error?.response?.status === 401) handle401(dispatch);
      throw error;
    }
  };
};
